import { requestClient } from '#/api/request';

const base = '/merchant/tiktok-operations';

export interface TiktokAftersalesItem {
  aftersaleTime?: number;
  appProfile?: string;
  buyerPaidAmount?: MoneyValue;
  createTime?: number;
  estimatedPayoutAmount?: MoneyValue;
  lineItems?: Array<Record<string, any>>;
  orderId?: string;
  orderAmount?: MoneyValue;
  orderedTime?: number;
  paidTime?: number;
  refundAmount?: MoneyValue;
  linkedShippedPurchaseOrderIds?: number[];
  nextActions?: Array<Record<string, any>>;
  processingDeadline?: number;
  returnId?: string;
  returnProviderName?: string;
  returnProviderId?: string;
  returnInboundDisabledReason?: string;
  returnInboundEligible?: boolean;
  returnInboundOrderId?: number;
  returnInboundOrderNo?: string;
  returnInboundStatus?: string;
  returnInboundStatusLabel?: string;
  returnReason?: string;
  returnReasonText?: string;
  returnStatus?: string;
  returnTrackingNumber?: string;
  returnType?: string;
  returnWarehouse?: Record<string, any>;
  shippedTime?: number;
  sellerType?: string;
  settlementAmount?: MoneyValue;
  shopId?: number;
  shopName?: string;
  updateTime?: number;
}

export type MoneyValue = number | Record<string, any> | string;

export interface TiktokAftersalesPage {
  lastSyncedAt?: number;
  mutationEnabled?: boolean;
  pageNum?: number;
  pageSize?: number;
  rows?: TiktokAftersalesItem[];
  syncing?: boolean;
  total?: number;
  warnings?: string[];
}

export function searchTiktokAftersalesApi(data: Record<string, any>) {
  return requestClient.post<TiktokAftersalesPage>(
    `${base}/aftersales/search`,
    data,
    { timeout: 60_000 },
  );
}

export function syncTiktokAftersalesApi(data: { shopId?: number }) {
  return requestClient.post<Record<string, any>>(
    `${base}/aftersales/sync`,
    data,
  );
}

export interface TiktokAftersalesDecision {
  comment?: string;
  decision: string;
  rejectReason?: string;
  returnId: string;
  shopId: number;
}

export function getTiktokAftersalesDecisionEligibilityApi(
  data: TiktokAftersalesDecision,
) {
  return requestClient.post<Record<string, any>>(
    `${base}/aftersales/decision-eligibility`,
    data,
  );
}

export function approveTiktokAftersalesApi(data: TiktokAftersalesDecision) {
  return requestClient.post<Record<string, any>>(
    `${base}/aftersales/approve`,
    data,
  );
}

export function rejectTiktokAftersalesApi(data: TiktokAftersalesDecision) {
  return requestClient.post<Record<string, any>>(
    `${base}/aftersales/reject`,
    data,
  );
}
